import { reduxKey } from '../../modals/WriterPopup/redux/constants';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { PapiDeviation } from '@wix/da-papi-types';

export const getWriterDeviation = (state): PapiDeviation | undefined =>
  getDeviationById(state, state[reduxKey] && state[reduxKey].deviationId);

export const getWriterError = state => state[reduxKey] && state[reduxKey].error;

export const getIsWriterSubmitting = state =>
  state[reduxKey] && state[reduxKey].isSubmitting;

export const getIsWriterDeviationFeatured = state =>
  (state[reduxKey] && state[reduxKey].isFeatured) || false;
